let activeSaleGuid = null;
let lastEditedGuid = null;

function collectSelectedGifts() {
  const selected = [];
  const activeTab = document.querySelector(".tab-content.active");

  if (!activeTab) return selected;

  activeTab.querySelectorAll(".gift-checkbox:checked").forEach((checkbox) => {
    const guid = checkbox.dataset.guid;
    const price = parseFloat(checkbox.dataset.price);
    const quantityInput = activeTab.querySelector(`.gift-quantity[data-guid="${guid}"]`);
    const quantity = parseInt(quantityInput?.value || "1", 10);
    const amount = price * quantity;

    selected.push({
      sale_guid: activeSaleGuid,
      guid: guid,
      quantity: quantity,
      price: price,
      amount: amount
    });
  });

  return selected;
}

function sendSelectedGifts() {
  const selectedGifts = collectSelectedGifts();
  if (!activeSaleGuid) return;

  fetch("/carts/update_selected_gifts", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
    },
    body: JSON.stringify({
      selected_gifts: selectedGifts,
      sale_guid: activeSaleGuid,
      last_edited_guid: lastEditedGuid
    })
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.success) {
        updateGiftSelections(data.selected_gifts);
        hideIgnoredGifts(data.ignored_gifts);
        document.getElementById("gift-note").innerText = data.note;
      } else {
        alert("Помилка: " + (data.error_message || data.reason || "Невідома помилка"));
      }
    });
}

function updateGiftSelections(selectedGifts) {
  const activeTab = document.querySelector(".tab-content.active");
  if (!activeTab) return;

  activeTab.querySelectorAll(".gift-checkbox").forEach((checkbox) => {
    checkbox.checked = false;
  });

  activeTab.querySelectorAll(".gift-quantity").forEach((input) => {
    input.disabled = true;
    input.value = 1;
  });

  selectedGifts.forEach((gift) => {
    const checkbox = activeTab.querySelector(`.gift-checkbox[data-guid="${gift.guid}"]`);
    const quantityInput = activeTab.querySelector(`.gift-quantity[data-guid="${gift.guid}"]`);

    if (checkbox) checkbox.checked = true;
    if (quantityInput) {
      quantityInput.disabled = false;
      quantityInput.value = gift.quantity;
    }
  });
}

function hideIgnoredGifts(ignoredGuids) {
  const activeTab = document.querySelector(".tab-content.active");
  if (!activeTab || !Array.isArray(ignoredGuids)) return;

  activeTab.querySelectorAll(".gift-item").forEach((item) => {
    const checkbox = item.querySelector(".gift-checkbox");
    const guid = checkbox?.dataset.guid;

    if (ignoredGuids.includes(guid)) {
      checkbox.style.display = "none";
      item.classList.add("gift-ignored");
    } else {
      checkbox.style.display = "";
      item.classList.remove("gift-ignored");
    }
  });
}

export function initGiftTabs() {
  const buttons = document.querySelectorAll(".tab-button");
  const contents = document.querySelectorAll(".tab-content");

  buttons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const targetId = this.getAttribute("data-tab");
      activeSaleGuid = targetId.replace("tab-", "");

      buttons.forEach((b) => b.classList.remove("active"));
      contents.forEach((c) => c.classList.remove("active"));

      this.classList.add("active");
      const targetContent = document.getElementById(targetId);
      if (targetContent) {
        targetContent.classList.add("active");
      }

      sendSelectedGifts();
    });
  });

  document.querySelectorAll(".gift-checkbox").forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const giftItem = this.closest(".gift-item");
      const quantityInput = giftItem.querySelector(".gift-quantity");
      quantityInput.disabled = !this.checked;
      lastEditedGuid = this.dataset.guid;
      sendSelectedGifts();
    });
  });

  document.querySelectorAll(".gift-quantity").forEach((input) => {
    input.addEventListener("change", function () {
      lastEditedGuid = this.dataset.guid;
      sendSelectedGifts();
    });
  });

  const firstActive = document.querySelector(".tab-button.active");
  if (firstActive) {
    activeSaleGuid = firstActive.getAttribute("data-tab").replace("tab-", "");
  }
}
